import { apiRequest } from '../../../../../../shared/services/api/apiRequest';
import { getTrackingMetadata } from '../getTrackingMetadata';

export interface VideoRoomErrorLogRequest {
  room_id: number;
  error_message: string;
  error_type: string;
  additional_data?: Record<string, any>;
}

export interface VideoRoomErrorLogResponse {
  message: string;
}

export const logVideoRoomError = async (
  roomId: number,
  errorMessage: string,
  errorType: string,
  additionalData: Record<string, any> = {},
  user: { id: number } | null = null
): Promise<VideoRoomErrorLogResponse> => {
  // Get tracking metadata
  const trackingMetadata = getTrackingMetadata(user);
  
  // Include tracking metadata in the request
  const requestWithMetadata: VideoRoomErrorLogRequest = {
    room_id: roomId,
    error_message: errorMessage,
    error_type: errorType,
    additional_data: additionalData,
    ...trackingMetadata,
  };
  
  return apiRequest('/api/video-room/error-log/', 'POST', requestWithMetadata);
};
